import { computed, ref, toValue, watch } from 'vue'
import type { MaybeRefOrGetter } from 'vue'
import type { AmazzingListingFiltersMeta } from '~~/shared/types/store'

export function useAmazzingFilterPanels(input: {
  currentUrl: MaybeRefOrGetter<string>
  filtersMeta?: MaybeRefOrGetter<AmazzingListingFiltersMeta | undefined>
}) {
  const lastUrl = ref(toValue(input.currentUrl))
  const showAllFilters = ref(false)

  const canExpandFilters = computed(() => Boolean(toValue(input.filtersMeta)?.truncated))

  function expandAllFilters() {
    if (canExpandFilters.value) {
      showAllFilters.value = true
    }
  }

  function collapseAllFilters() {
    showAllFilters.value = false
  }

  async function syncUrl(nextUrl: string) {
    if (nextUrl !== lastUrl.value) {
      lastUrl.value = nextUrl
      showAllFilters.value = false
    }
  }

  watch(
    () => toValue(input.currentUrl),
    (nextUrl) => {
      if (nextUrl !== lastUrl.value) {
        lastUrl.value = nextUrl
        showAllFilters.value = false
      }
    },
  )

  return {
    showAllFilters,
    canExpandFilters,
    expandAllFilters,
    collapseAllFilters,
    syncUrl,
  }
}
